import { render, staticRenderFns } from "./warning-manage-list.vue?vue&type=template&id=55712634&scoped=true&"
import script from "./warning-manage-list.vue?vue&type=script&lang=js&"
export * from "./warning-manage-list.vue?vue&type=script&lang=js&"
import style0 from "./warning-manage-list.vue?vue&type=style&index=0&id=55712634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55712634",
  null
  
)

export default component.exports